<template>

<core-modal-setting title="Custom Width" :value="valueText" placeholder="Default">
        
   <core-input-textbox 
		:autofocus="true" 
		maxlength="3" 
		placeholder="Enter pixel width" 
		v-model="internalValue"
	/>

</core-modal-setting>

</template>

<script>

import mixSetting from 'core/mixin/modal/Setting'

export default {

    mixins: [mixSetting],

    computed: {

        valueText: function() {

            return ((this.internalValue) ? this.internalValue.toString() : '0') + 'px'

        }

    }

}

</script>

<style scoped>

</style>